import { createContext, useContext } from 'react';

import type { GMetrixTableContextValue } from 'components/GMetrixTable/GMetrixTable';

export const GMetrixTableContext = createContext({} as GMetrixTableContextValue);
GMetrixTableContext.displayName = 'GMetrixTableContext';

export const useGMetrixTable = () => useContext(GMetrixTableContext);
